import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Filter24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 7.36842C4 6.88881 4.38376 6.5 4.85714 6.5H19.1429C19.6162 6.5 20 6.88881 20 7.36842C20 7.84804 19.6162 8.23684 19.1429 8.23684H4.85714C4.38376 8.23684 4 7.84804 4 7.36842ZM16.8571 12.8684L7.14286 12.8684C6.66947 12.8684 6.28571 12.4796 6.28571 12C6.28571 11.5204 6.66947 11.1316 7.14286 11.1316L16.8571 11.1316C17.3305 11.1316 17.7143 11.5204 17.7143 12C17.7143 12.4796 17.3305 12.8684 16.8571 12.8684ZM13.4286 17.5L10.5714 17.5C10.098 17.5 9.71429 17.1112 9.71429 16.6316C9.71429 16.152 10.098 15.7632 10.5714 15.7632L13.4286 15.7632C13.902 15.7632 14.2857 16.152 14.2857 16.6316C14.2857 17.1112 13.902 17.5 13.4286 17.5Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
